import { render, staticRenderFns } from "./AsideModal.vue?vue&type=template&id=84faa4ac"
import script from "./AsideModal.vue?vue&type=script&lang=js"
export * from "./AsideModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports